import React, { Component } from 'react';
import {Button, Checkbox, Flex, List, Tag,Icon} from 'antd-mobile';
import InputNumber from '../../../components/InputNumber';
const CheckboxItem = Checkbox.CheckboxItem;

export default class PreBirthWeek extends Component {
  constructor (props) {
    super(props);
    this.state = {
      bw1: 4,
      bw2: 8,
      bw3: 16,
      bw4: 26,
      check1: true,
      check2: true,
      check3: true,
      check4: true
    }
  }
  componentWillMount() {
    const {value} = this.props;
    this.setState({
      ...value
    })
  }
  change = (key, value) => {
    this.setState({
      [key]: value
    })
  };
  ok = () => {
    typeof this.props.onConfirm === 'function' && this.props.onConfirm(this.state);
    typeof this.props.onCancel === 'function' &&this.props.onCancel()
  };
  cancel = () => {
    const {value} = this.props;
    this.setState({
      ...value
    });
    typeof this.props.onCancel === 'function' &&this.props.onCancel()
  };
  render() {
    const {bw1, bw2, bw3, bw4, check1, check2, check3, check4} = this.state;
  return (
    <List style={{backgroundColor: '#fff'}}>
      {this.state.aaa}
      <Flex wrap={'wrap'}>
        <Flex.Item>
          <div style={{position:'relative', width: '30vw'}}>
            {
              check1 ? <Icon className={'rightT'}
                  color="#108EE9"
                  onClick={() => {this.change('check1', false)}}
                  type="check-circle"
                       />: <span className="circle rightT"
                           onClick={() => {this.change('check1', true)}}
                           />
            }
            <InputNumber className="input-bordered"
                disabled={!check1}
                onChange={(bw1) => {
                           this.setState({
                             bw1: bw1
                           })
                         }}
                style={{textAlign: 'center'}}
                type="number"
                value={bw1}
            />
          </div>
        </Flex.Item>
        <Flex.Item>
          <div style={{position:'relative', width: '30vw'}}>
            {
              check2 ? <Icon className={'rightT'}
                  color="#108EE9"
                  onClick={() => {this.change('check2', false)}}
                  type="check-circle"
                       />: <span className="circle rightT"
                           onClick={() => {this.change('check2', true)}}
                           />
            }
            <InputNumber className="input-bordered"
                disabled={!check2}
                onChange={(bw2) => {
                           this.setState({
                             bw2
                           })
                         }}
                style={{textAlign: 'center'}}
                type="number"
                value={bw2}
            />
          </div>
        </Flex.Item>
        <Flex.Item>
          <div style={{position:'relative', width: '30vw'}}>
          {
              check3 ? <Icon className={'rightT'}
                  color="#108EE9"
                  onClick={() => {this.change('check3', false)}}
                  type="check-circle"
                       />: <span className="circle rightT"
                           onClick={() => {this.change('check3', true)}}
                           />
            }
            <InputNumber className="input-bordered"
                disabled={!check3}
                onChange={(bw3) => {
                           this.setState({
                             bw3: bw3
                           })
                         }}
                style={{textAlign: 'center'}}
                type="number"
                value={bw3}
            />
          </div>
        </Flex.Item>
      </Flex>
      <div style={{position:'relative',marginTop: 10, width: '30vw'}}>
        {
          check4 ? <Icon className={'rightT'}
                         color="#108EE9"
                         onClick={() => {this.change('check4', false)}}
                         type="check-circle"
          />: <span className="circle rightT"
                    onClick={() => {this.change('check4', true)}}
          />
        }
        <InputNumber className="input-bordered"
                     disabled={!check4}
                     onChange={(bw4) => {
                       this.setState({
                         bw4: bw4
                       })
                     }}
                     style={{textAlign: 'center'}}
                     type="number"
                     value={bw4}
        />
      </div>
      <div style={{padding: '15px 10px'}}>
        <Flex>
          <Flex.Item>
            <Button onClick={this.cancel}>取消</Button>
          </Flex.Item>
          <Flex.Item>
            <Button onClick={this.ok}
                type="primary"
            >确定</Button>
          </Flex.Item>
        </Flex>
      </div>
    </List>
  )
 }
}
